export default __webpack_public_path__ + "static/cellEditing-5817003f4ce8aa4d318d2f3aa97cb105.gif";